// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KHIw","textarea":"styles_textarea__1_IXz"};